import { Injectable } from '@angular/core';

import { SOCIALS_CONFIG, SUPPORT_EMAIL } from './social-link.const';
import type { ISocialLinkService } from './social-link.type';

@Injectable({ providedIn: 'root' })
export class SocialLinkService implements ISocialLinkService {
  readonly socials = Object.values(SOCIALS_CONFIG);
  readonly config = SOCIALS_CONFIG;
  readonly supportEmail = SUPPORT_EMAIL;
}
